import * as angular from 'angular';
import { AssignSupportsComponent } from './assign-supports/assign-supports.component';
import { GradPlansStepComponent } from './complete-grad-planning/grad-plans.component';
import { FinalPrepCheckComponent } from './final-prep-check/final-prep-check.component';
import { InstructionStepComponent } from './instruction/instruction.component';
import { MonitorAttendanceComponent } from './monitor-attendance/monitor-attendance.component';
import { PrepReviewComponent } from './prep-review/prep-review.component';
import { PrintRegentsComponent } from './print-regents/print-regents.component';
import { SchedulingCheckComponent } from './scheduling-check/scheduling-check.component';
import { TrackAttendanceComponent } from './track-attendance/track-attendance.component';

export const SharedRegentsPrepStepComponentsModule = angular
  .module('sharedRegentsPrepStepComponentsModule', [])
  .component('instructionStepComponent', InstructionStepComponent)
  .component('gradPlansStepComponent', GradPlansStepComponent)
  .component('schedulingCheckComponent', SchedulingCheckComponent)
  .component('prepReviewComponent', PrepReviewComponent)
  .component('assignSupportsComponent', AssignSupportsComponent)
  .component('finalPrepCheckComponent', FinalPrepCheckComponent)
  .component('printRegentsComponent', PrintRegentsComponent)
  .component('trackAttendanceComponent', TrackAttendanceComponent)
  .component('monitorAttendanceComponent', MonitorAttendanceComponent).name;
